import { compose, withHandlers, withState } from 'recompose';

const withHover = compose(
  withState('hover', 'setHover', false),
  withHandlers({
    onMouseEnter: ({ setHover }) => () => {
      setHover(true);
    },
    onMouseLeave: ({ setHover }) => () => {
      setHover(false);
    },
  }),
);

export default withHover;
